import { render, staticRenderFns } from "./SelectWidgetModal.vue?vue&type=template&id=49bae618&scoped=true&"
import script from "./SelectWidgetModal.vue?vue&type=script&lang=js&"
export * from "./SelectWidgetModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectWidgetModal.vue?vue&type=style&index=0&id=49bae618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bae618",
  null
  
)

export default component.exports